import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'src/app/_models/subscription';
import { AdminSubscriptionService } from 'src/app/_services/admin-subscription.service';

@Component({
    selector: 'app-subscription-detail',
    templateUrl: './subscription-detail.component.html',
    styleUrls: ['./subscription-detail.component.css'],
    standalone: false
})
export class SubscriptionDetailComponent implements OnInit {
    subscription: Subscription;
    subscriptionId: string;
    loading = true;

    constructor(
        private adminSubscriptionService: AdminSubscriptionService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private toast: ToastrService
    ) {
        this.subscriptionId = this.activatedRoute.snapshot.paramMap.get('id') ?? '';
    }

    ngOnInit(): void {
        if (!this.subscriptionId) {
            this.toast.error('Subscription ID is required');
            this.router.navigate(['/admin/subscriptions']);
            return;
        }

        this.adminSubscriptionService.loadSubscription(this.subscriptionId).subscribe({
            next: (response: any) => {
                console.log('FULL RESPONSE =>', response);
                console.log('response.data =>', response?.data);

                // Try Swagger structure first (double-wrapped)
                if (response?.data && typeof response.data === 'object' && !Array.isArray(response.data)) {
                    this.subscription = response.data;
                }
                // Fallback if service already unwraps data
                else if (response && typeof response === 'object' && !Array.isArray(response)) {
                    this.subscription = response;
                }
                else {
                    console.error('Unexpected response structure', response);
                    this.subscription = undefined;
                }

                console.log('SUBSCRIPTION =>', this.subscription);
                this.loading = false;
            },
            error: (err) => {
                console.error('API ERROR =>', err);
                if (err?.status !== 401 && err?.status !== 403) {
                    this.toast.error('Error loading subscription details');
                }
                this.loading = false;
            }
        });
    }

    goBack(): void {
        this.router.navigate(['/admin/subscriptions']);
    }
}
